<template>
  <div class="app_container">
    <el-table :data="numData" border style="width: 50%">
      <el-table-column prop="totalNum" label="总数量" width="180">
      </el-table-column>
      <el-table-column prop="importableNum" label="可导入数量" width="180">
      </el-table-column>
      <el-table-column prop="unImportableNum" label="不可导入数量">
      </el-table-column>
    </el-table>
    <div class="error-title">
      不可导入说明：
      <butn
        btntype="primary"
        title="导出"
        @click="exportError"
      ></butn>
    </div>
    <Table :data="errorList" row-key="uuid"/>
    <div class="RCPagination">
      <butn
        style="float: left;"
        btntype="primary"
        iconName="el-icon-arrow-left"
        title="返回"
        @click="$router.back()"
      ></butn>
    </div>
  </div>
</template>

<script>
import ExportJsonExcel from 'js-export-excel';
import Table from "./table.js";
import butn from "@/components/button/index";
export default {
  components: {
    Table,
    butn,
  },
  data() {
    return {
      numData: [],
      errorList: []
    };
  },
  created() {
    let data = JSON.parse(localStorage.getItem("errorExcelData"));
    this.numData = [
      {
        totalNum: data.totalNum,
        importableNum: data.importableNum,
        unImportableNum: data.unImportableNum
      }
    ];
    this.errorList = data.errorImportExcelVoList;
  },
  methods: {
    exportError() {
      var data = this.errorList; //选中的数据
      let dataTable = [];
      if (data && data.length > 0) {
        for (let i in data) {
          if (data[i]) {
            let obj = {
              "所在行": data[i].row,
              "唯一标识": data[i].unique,
              "错误原因": data[i].reason
            };
            dataTable.push(obj);
          }
        }
        this.exportToExcel(dataTable);
      }
    },
    exportToExcel(dataTable) {
      var option = {};
      option.fileName = "导入错误说明";
      option.datas = [
        {
          sheetData: dataTable,
          sheetName: "sheet",
          sheetFilter: [
            "所在行",
            "唯一标识",
            "错误原因"
          ],
          sheetHeader: [
            "所在行",
            "唯一标识",
            "错误原因"
          ]
        }
      ];
      var toExcel = new ExportJsonExcel(option);
      toExcel.saveExcel();
    },
  }
};
</script>

<style lang="scss" scoped>
.search-wrapper {
  float: right;
}
.handle-wrapper {
  float: left;
}
.error-title {
  margin: 20px 0;
  font-size: 15px;
  font-weight: 500;
  color: #51627d;
}
</style>
